// extracted by mini-css-extract-plugin
export default {"home":"FinalExam_home__zgoiR","home2":"FinalExam_home2__TBDEt","hr":"FinalExam_hr__l1EYK","main":"FinalExam_main__tYMhu"};